import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"
import { useToast } from "@/components/ui/ToastProvider"
import { IconLoader } from "@/components/ui/Icons"

export default function ResetPasswordPage() {
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { success, error: showError } = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      const { error } = await supabaseClient.auth.updateUser({ password })
      if (error) { showError("Error", error.message); return }
      success("Password updated!")
      navigate("/auth/login")
    } finally { setLoading(false) }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="auth-card w-full max-w-[350px]">
        <h2 className="font-semibold text-base mb-4 text-center">Set new password</h2>
        <form onSubmit={handleSubmit} className="space-y-3">
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="New password" className="input-ig" required minLength={8} />
          <button type="submit" disabled={loading} className="btn-ig w-full py-2.5">
            {loading ? <IconLoader className="w-4 h-4 animate-spin" /> : "Update password"}
          </button>
        </form>
      </div>
    </div>
  )
}